import { render, staticRenderFns } from "./spuTab.vue?vue&type=template&id=5644767c&"
import script from "./spuTab.vue?vue&type=script&lang=ts&"
export * from "./spuTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports